import axios from "axios";
import apiPath from "../constants/apiPath";
import { useCallback, useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const client = axios.create({
  baseURL: apiPath.baseURL,
});

const getStoredToken = () => {
  const directToken = localStorage.getItem("token");
  if (directToken) return directToken;
  try {
    const loginDataRaw = localStorage.getItem("loginData");
    if (!loginDataRaw) return "";
    const loginData = JSON.parse(loginDataRaw);
    return (
      loginData?.token ||
      loginData?.accessToken ||
      loginData?.jwt ||
      loginData?.data?.token ||
      loginData?.data?.accessToken ||
      loginData?.Details?.token ||
      ""
    );
  } catch (_err) {
    return "";
  }
};

const getLoginRouteByRole = () => {
  const role = localStorage.getItem("authRole");
  return role === "admin" ? "/admin/login" : "/login";
};

const useRequest = () => {
  const { logout } = useContext(AuthContext);

  const request = useCallback(
    async ({
      url,
      method: tmethod,
      data,
      onSuccess,
      onError,
      header,
      headers: customHeaders,
      onErrorSubmit,
      params,
      finally: finallyCallback,
    }) => {
      const method = tmethod.trim().toUpperCase();

      const token = getStoredToken();
      if (token && !localStorage.getItem("token")) {
        localStorage.setItem("token", token);
      }

      const requestHeaders = {
        ...(header || customHeaders),
        Authorization: `Bearer ${token}`,
      };

      // Don't set Content-Type if data is FormData - let axios handle it
      if (!(data instanceof FormData)) {
        requestHeaders["Content-Type"] = "application/json";
      }

      try {
        const response = await client({
          url,
          method,
          data,
          params,
          headers: requestHeaders,
        });

        if (onSuccess) {
          onSuccess(response.data);
        } else {
          // onErrorSubmit(response.data);
        }

        return response.data;
      } catch (err) {
        console.log(err, "Error");
        if (err?.response?.code === "ERR_NETWORK") {
          console.log("ErrorNetwork");
        }

        // Check if this is a login endpoint - don't logout on login failures
        const isLoginEndpoint =
          url &&
          (
            url.includes("/login") ||
            url.includes("auth/login") ||
            url.includes("/hotel_partnerLogin") ||
            url.includes("/agent_login")
          );
        const hasToken = !!token;

        if (err?.response?.status === 401) {
          // Check if it's a session termination
          if (
            err?.response?.data?.message?.includes("Session expired") ||
            err?.response?.data?.message?.includes("Session terminated") ||
            err?.response?.data?.message?.includes("inactivity")
          ) {
            // Session terminated, logout immediately
            localStorage.removeItem("token");
            localStorage.removeItem("userProfile");
            window.location.href = getLoginRouteByRole();
          } else if (!isLoginEndpoint && hasToken) {
            // Only logout if it's NOT a login endpoint and user has a token (authenticated request failed)
            logout();
          }
          // If it's a login endpoint, don't call logout - just let onError handle it
        }
        // Do not auto-logout on 403 (permission mismatch). Keep session active.
        if (err?.response?.data?.message === "jwt expired" && !isLoginEndpoint) {
          // Only logout for jwt expired if it's not a login endpoint
          logout();
        }
        if (onError) {
          console.log(err);
          onError(err);
        }
        // throw err;
      } finally {
        // Always execute finally callback if provided
        if (finallyCallback) {
          finallyCallback();
        }
      }
    },
    [logout]
  );

  return { request };
};

export default useRequest;
